export const chatBot = {
  abortedResponse: "Die Antwort wurde abgebrochen.",
  avatar: "Avatar des Chatbots",
  errorMessage:
    "Entschuldigung, es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  errorMessageSend: "Ein Fehler ist beim Senden der Nachricht aufgetreten.",
  errorMessageUnexpectedError: "Ein unerwarteter Fehler ist aufgetreten.",
  inputPlaceholder: "Stell deine Frage",
  openButtonLabel: "Assistant öffnen",
  sendButtonLabel: "Senden",
  title: "Xentral AI Assistant",
  today: "Heute, ",
  welcomeMessage: "Hallo! Wie kann ich Ihnen helfen?",
  explainErrorButtonLabel: "Fehler erklären lassen",
  explainErrorTemplate:
    "Folgende Fehlermeldung ist in der SCMA '{appName}' aufgetreten: '{error}'. Erkläre dies und sag mir, wie ich es beheben kann."
};
